export default {
	COMPANIES: 'companies/',
	ADMIN: 'companies/:company_id/admin/',
	ACTIVE_ADMIN: 'companies/:company_id/admin/active/users',
	ROLES: 'companies/:company_id/admin/roles/'
}
